<div class="r-form-group search-container">
    <div class="row" style="align-items:center">
        <p-button type="button" class="filter-btn" (click)="displaySidebar = true" icon="pi pi-filter"></p-button>
        <app-atn-export-excel [request]="request" [fileName]="'businesses'"></app-atn-export-excel>
        <!-- <app-atn-export-excel [request]="request" [fileName]="'BusinessCoupon'"></app-atn-export-excel> -->
    </div>
</div>
<p-sidebar [(visible)]="displaySidebar" [baseZIndex]="10000">
    <div class="header">{{'LIDS.TITLE_SIDEBAR' |translate}}</div>

    <div class="filters">
        <div class="r-form-group">
            <label class="title">{{'LIDS.SEARCH' |translate}}</label>
            <input [(ngModel)]="freeSearch" type="text" pInputText size="50"
                placeholder="{{'BUSINESS_MANAGEMENT.FREE_SEARCH' |translate}}" (delayEvent)="filterfreeSearch()"
                delayEventName="onkeyup">
        </div>

    </div>
</p-sidebar>
<div class="r-form-group totalRecords">
    {{ totalRecords }} {{ 'BUSINESS_MANAGEMENT.TITLE' | translate }}
</div>


<div class="cards-container">
  <app-business-management-card-mobile
    *ngFor="let business of businessRoulettes$ | async"
    [currentBusiness]="business"
    [columns]="columns"
    (cardClick)="onBusinessClick($event)">
  </app-business-management-card-mobile>
</div>

<p-paginator
 [rows]="50"
  [totalRecords]="totalRecords"
  (onPageChange)="onPageChange($event)">
</p-paginator>
